import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Stack,
  Paper,
  Rating
} from "@mui/material";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";

const VoteDisplay = () => {
  const { eventId } = useParams();
  const { userData } = useContext(EventContext);
  const [loading, setLoading] = useState(true);
  const [pitches, setPitches] = useState([]);
  const [title, setTitle] = useState("");
  const [style, setStyle] = useState({backgroundColor: "#C7513E"})

  useEffect(() => {
    if (!userData) return;
    setStyle({backgroundColor: userData?.org?.style?.primaryColor})
  },[userData])


  const getVotes = async () => {
    if (!eventId) return;

    try {
      setLoading(true);

      const result = await request(
        `pitchesadmin/votes?eventId=${eventId}`,
      );

      if (result.success) {
        setTitle(result.voteScreenTitle || "")
        setPitches(result.pitches || []);
      }

      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    getVotes();
  }, [eventId]);

  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={80} />
      </Box>
    );
  }

  return (
  <Box
    sx={{
      height: "100vh",
      width: "100%",
      p: 3,
      boxSizing: "border-box",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      backgroundColor: style?.backgroundColor
    }}
  >
    <Typography variant="h2" align="center" sx={{ mb: 4, color: 'white' }}>
      {title}
    </Typography>

    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      sx={{ flex: 1, width: "100%" }}
    >
      {pitches.map((pitch, index) => (
        <Paper
          key={pitch._id}
          sx={{
            height: `calc((100vh - 180px) / ${pitches.length + 2})`,
            display: "flex",
            overflow: "hidden",
            py: 0,
            px: 0,
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: 10,
            border: index === 0 ? "3px solid gold" : "none",
            width: "70%",
            maxWidth: 900,
            background: index === 0
              ? "linear-gradient(135deg, #FFD700 0%, #FFC300 20%, #FFF3B0 40%, #FFD700 60%, #B8960B 80%, #FFD700 100%)"
              : "white",
            boxShadow: index === 0 ? "0 0 20px rgba(255,215,0,0.6), inset 0 0 10px rgba(255,255,255,0.6)" : undefined
          }}
        >
          <Box sx={{ display: "flex", height: "100%", width: "100%" }}>

            <Box
              sx={{
                width: "15%",
                minWidth: 120,
                height: "100%",
                backgroundImage: `url(${pitch.profileImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                WebkitMaskImage: "linear-gradient(to right, black 80%, transparent 100%)",
                maskImage: "linear-gradient(to right, black 80%, transparent 100%)"
              }}
            />

            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 4
              }}
            >
              <Box>
                <Typography variant="h4">
                  {pitch.firstName} {pitch.lastName}
                </Typography>

                <Rating
                  value={pitch.avgScore || 0}
                  precision={0.1}
                  readOnly
                  size="large"
                  sx={{
                    color: index === 0 ? "#C7513E" : "#FFC107",
                    fontSize: "3rem"
                  }}
                />
              </Box>

              <Box sx={{ textAlign: "right" }}>
                <Typography variant="h4">
                  {pitch.avgScore?.toFixed(2) || "0.00"}
                </Typography>
                <Typography variant="body1">
                  {pitch.voteCount || 0} ratings
                </Typography>
              </Box>

            </Box>
          </Box>
        </Paper>
      ))}
    </Stack>
  </Box>
  );
};

export default VoteDisplay;
